import {IS_LOGGED_IN, SHOW_MSG} from "../types";
import {replace} from 'react-router-redux';
import call from './call';
import {CHANGE_PASSWORD_ROUTE, MAIN_ROUTE} from "../components/Main/routes";

export default (userName,password) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result)
        {
            dispatch({type: IS_LOGGED_IN, payload: {auth: {logged: result[1].logged,userName:userName,role:result[1].role,isRA:result[1].ra,queryLimit:result[1].queryLimit}}});
            if (result[1].success)
            {
                if(result[1].status==='CHANGE')
                {
                    dispatch({type: SHOW_MSG, payload: {message: result[1].detail,type:'success'}});
                    dispatch(replace(CHANGE_PASSWORD_ROUTE));
                }
                else
                {
                    dispatch(replace(MAIN_ROUTE));
                }
            }
        }
    }
    dispatch(call("LoginService/checkBasicAuthentication",{userName:userName,password:password},onResult));
};